import { styled } from '@mui/material';

export const RefundChargebackReportSummaryDropdownStyled = styled('div')<{ isOpen: boolean }>(
  ({ theme, isOpen }) => ({
    width: '100%',
    height: '64px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: `1px solid ${theme.palette.divider}`,
    borderBottom: isOpen ? 'none' : `1px solid ${theme.palette.divider}`,
    borderTopRightRadius: '4px',
    borderTopLeftRadius: '4px',
    borderBottomRightRadius: isOpen ? 0 : '4px',
    borderBottomLeftRadius: isOpen ? 0 : '4px',
    padding: '0 16px',
    backgroundColor: theme.palette.background.default,
  }),
);
